import useReportsVersion from '@features/reports2/hooks/useReportsVersion';
import { Suspense, type FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ReportsV1GuardInner: FC = () => {
  const { version } = useReportsVersion();

  if (version !== 'v1') {
    return <Navigate to="/reports" replace />;
  }

  return <Outlet />;
};

const ReportsV1Guard: FC = () => (
  <Suspense fallback={null}>
    <ReportsV1GuardInner />
  </Suspense>
);

export default ReportsV1Guard;
